import { waitForJob } from "../../../common/job_poll.es6";
import { insertLogoIntroScene } from "./insertLogoIntroScene";

// jobId → the in-flight wait. Module-level on purpose: the wait must outlive
// the panel (closing it mid-render still gets the intro inserted), and a
// second request for the same job must not insert the scene twice.
const pending = new Map();

/** Where to insert, read from the store when the job finishes, not when it started. */
function insertCtx(state, opts) {
  const present = (state && state.undoGroup && state.undoGroup.present) || {};
  const byId = present.navItemsById || {};
  return {
    placement: opts.placement,
    afterNavId: opts.afterNavId,
    sceneName: opts.sceneName,
    navItemsIds: present.navItemsIds || [],
    navItemsById: byId,
    rootChildren: (byId[0] && byId[0].children) || [],
    boxes: present.boxesById || {},
  };
}

/**
 * Thunk: wait for a logo intro mp4 / WebP render job and insert the scene
 * when it completes. Resolves with the inserted result; rejects with the
 * job's error (nothing is inserted then).
 *
 * @param {string} jobId
 * @param {object} accepted - the 202 body: { navId, boxId, output, durationSec }
 * @param {{ placement: "start"|"after", afterNavId?: string, sceneName: string }} opts
 */
export function insertLogoIntroWhenRendered(jobId, accepted, opts) {
  return (dispatch, getState) => {
    if (pending.has(jobId)) return pending.get(jobId);
    const run = waitForJob(jobId)
      .then((done) => {
        const result = {
          navId: done.navId || accepted.navId,
          boxId: done.boxId || accepted.boxId,
          url: done.url,
          kind: done.kind || accepted.output,
          durationSec: done.durationSec || accepted.durationSec,
        };
        insertLogoIntroScene(dispatch, result, insertCtx(getState(), opts));
        return result;
      })
      .finally(() => pending.delete(jobId));
    pending.set(jobId, run);
    return run;
  };
}
